import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src436426409/src/collinson-group-web/src/components/Breadcrumbs/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/codebuild/output/src436426409/src/collinson-group-web/src/contexts/SettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src436426409/src/collinson-group-web/src/features/contentful/containers/Insights/InsightsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src436426409/src/collinson-group-web/src/layouts/OpenAccessLayout.tsx");
